import { mobileViewActions } from '../../services';


export const mobileViewDispatcher = dispatch => ({
  listView: () => dispatch( { type: mobileViewActions.LISTVIEW} ),

  mediaView: () => dispatch( { type: mobileViewActions.MEDIAVIEW} )
});